<template>
    <div class="Index">
        <div class="content" :style="{backgroundImage:`url(${ImageUrl})`}">
            <!-- <img src="" class="img-fluid" alt="Responsive image"> -->
            <div class="content-detail">
                <h1 data-delighter class="left" style="color: #5fe0c6;">B2B</h1>
                <h1 data-delighter class="right">企业办公解决方案（企业微信/钉钉扫码打印）</h1>
                <p data-delighter class="left">借助印点点的嵌入式自助打印软件，将传统复印机升级为云办公复印机，</p>
                <p data-delighter class="right">员工打开移动办公App，扫描屏幕二维码，选择手机文件即可打印输出；</p>
            </div>
        </div>
        <!-- content开始 -->
        <div class="container">
            <div class="row content-one">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 local">
                    <div class="card-deck">
                        <div class="col-xs-12 col-sm-6 col-md-2 col-lg-2 right">
                            <img class="card-img" src="../assets/wx-1.png" alt="Card image cap">
                            <div class="card-body">
                                <h5 class="card-title title">卓越方案</h5>
                                <h5 class="card-title title">完美覆盖各类场景</h5>
                            </div>
                        </div>
                        <div class="col-xs-12 col-sm-6 col-md-2 col-lg-2 right">
                            <img class="card-img" src="../assets/wx-2.png" alt="Card image cap">
                            <div class="card-body">
                                <h5 class="card-title title">创新计价模式</h5>
                                <h5 class="card-title title">无惧PK</h5>
                            </div>
                        </div>
                        <div class="col-xs-12 col-sm-6 col-md-2 col-lg-2 right">
                            <img class="card-img" src="../assets/wx-3.png" alt="Card image cap">
                            <div class="card-body">
                                <h5 class="card-title title">预付费模式</h5>
                                <h5 class="card-title title">改善资金流</h5>
                            </div>
                        </div>
                        <div class="col-xs-12 col-sm-6 col-md-2 col-lg-2 right">
                            <img class="card-img" src="../assets/wx-4.png" alt="Card image cap">
                            <div class="card-body">
                                <h5 class="card-title title">运维更高效</h5>
                                <h5 class="card-title title">客户更满意</h5>
                            </div>
                        </div>
                        <div class="col-xs-12 col-sm-6 col-md-2 col-lg-2 right">
                            <img class="card-img" src="../assets/wx-5.png" alt="Card image cap">
                            <div class="card-body">
                                <h5 class="card-title title">存量客户</h5>
                                <h5 class="card-title title">永不流失</h5>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                    <div class="card-deck card-list">
                        <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 list-icon">
                            <img class="icon icon-6" src="../assets/wx-6.png" alt="Card image cap">
                        </div>
                        <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 list-item">
                            <h2>卓越方案，完美覆盖各类场景</h2>
                            <p>印点点嵌入式自助打印软件可实现原有文印管理功能。使用指纹/刷脸门禁的无卡客户，通过微信扫码打印即可精准计费分账。</p>
                            <p>可同时支持刷卡打印、扫码打印，既保留传统方案的安全、高效，又丰富全新用户体验。</p>

                            <div class="row part">
                                <div class="col-4 col-md-4 area">
                                    <h1>精准</h1>
                                    <h5>精准计费分账</h5>
                                </div>
                                <div class="col-4 col-md-4 area">
                                    <h1>安全</h1>
                                    <h5>避免文件泄露</h5>
                                </div>
                                <div class="col-4 col-md-4 area">
                                    <h1>高效</h1>
                                    <h5>提高工作效率</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="dark">
            <div class="container">
                <div class="row content-one">
                    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                        <div class="card-deck card-list">
                            <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 list-item">
                                <h2>创新计价模式，无惧PK</h2>
                                <p>支持彩色动态计价，按彩打面积占比折算价格。保证利润的同时，</p>
                                <p>在竞争价格敏感客户时可轻松赢单。</p>

                                <div class="row part">
                                    <div class="col-4 col-md-4 area">
                                        <h1>创新</h1>
                                        <h5>彩色动态计价</h5>
                                    </div>
                                    <div class="col-4 col-md-4 area">
                                        <h1>赢利</h1>
                                        <h5>保证客户利润</h5>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 list-icon">
                                <img class="icon icon-2" src="../assets/wx-7.png" alt="Card image cap">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="">
            <div class="container">
                <div class="row content-one">
                    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                        <div class="card-deck card-list">
                            <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 list-icon">
                                <img class="icon-3" src="../assets/wx-8.png" alt="Card image cap">
                            </div>
                            <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 list-item">
                                <h2>预付费模式，改善资金流</h2>
                                <p>支持预付费模式，自动结算，主动回款，资金流更健康。支持按日/天租赁，</p>
                                <p>结算方式灵活。预充印费送印券，帮企业省钱，让行政省心。</p>

                                <div class="row part">
                                    <div class="col-4 col-sm-4 col-md-4 .col-lg-4 col-xl-4 area">
                                        <h1>自动</h1>
                                        <h5>自动结算资金</h5>
                                    </div>
                                    <div class="col-4 col-sm-4 col-md-4 .col-lg-4 col-xl-4 area">
                                        <h1>灵活</h1>
                                        <h5>结算方式灵活</h5>
                                    </div>
                                    <div class="col-4 col-sm-4 col-md-4 .col-lg-4 col-xl-4 area">
                                        <h1>省钱</h1>
                                        <h5>预充印费送印券</h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="dark">
            <div class="container">
                <div class="row content-one">
                    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                        <div class="card-deck card-list">
                            <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 list-item">
                                <h2>运维更高效，客户更满意</h2>
                                <p>自动叫修、主动巡防；客户行政、IT人员零参与；响应及时，客户满意度高。</p>
                                <p>提高人机服务覆盖比，客服成本降低。</p>

                                <div class="row part">
                                    <div class="col-4 col-md-4 area">
                                        <h1>自动</h1>
                                        <h5>自动叫修报障</h5>
                                    </div>
                                    <div class="col-4 col-md-4 area">
                                        <h1>低成本</h1>
                                        <h5>降低人工成本</h5>
                                    </div>
                                    <div class="col-4 col-md-4 area">
                                        <h1>省心</h1>
                                        <h5>让客户更满意</h5>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 list-icon">
                                <img class="icon icon-4" src="../assets/wx-9.png" alt="Card image cap">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="">
            <div class="container">
                <div class="row content-one">
                    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                        <div class="card-deck card-list">
                            <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 list-icon">
                                <img class="icon icon-5" src="../assets/wx-10.png" alt="Card image cap">
                            </div>
                            <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 list-item">
                                <h2>存量客户永不流失</h2>
                                <p>加机、复购全权掌握，业内独家方案，存量客户永不流失。</p>

                                <div class="row part">
                                    <div class="col-4 col-sm-4 col-md-4 .col-lg-4 col-xl-4 area">
                                        <h1>可靠</h1>
                                        <h5>设备灵活配置</h5>
                                    </div>
                                    <div class="col-4 col-sm-4 col-md-4 .col-lg-4 col-xl-4 area">
                                        <h1>独享</h1>
                                        <h5>专属独家方案</h5>
                                    </div>
                                    <div class="col-4 col-sm-4 col-md-4 .col-lg-4 col-xl-4 area">
                                        <h1>获客</h1>
                                        <h5>存量客户不流失</h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
  name: "Index",
  data() {
    return {
        ImageUrl:require('../assets/wx.png')
    };
  },
  created() {
    window.scrollTo(0, 0);
  }
};
</script>

<style lang="less" scoped>
.content {
    width: 100%;
    position: relative;
    height: 535px;
    background: no-repeat center center;
    background-size: cover;
}

.right {
    margin-right: 2.2rem;
}

.local {
    margin: -64px auto 0;
}

.icon-1 {
    width: 483px;
    height: 331px;
}

.icon-2 {
    width: 423px;
    height: 232px;
}

.icon-3 {
    width: 427px;
    height: 205px;
}

.icon-4 {
    width: 361px;
    height: 227px;
}

.icon-5 {
    width: 415px;
    height: 212px;
}
.icon-6 {
    width: auto;
    height: 350px;
}

.card-list {
    padding: 200px 0 158px;
}

.list-icon {
    display: flex;
    justify-content: center;
    position: relative;
}

.icon {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
}

.list-item {
    text-align: left;

    h2 {
        font-size: 40px;
        line-height: 28px;
        color: #18182a;
        margin-bottom: 24px;
    }

    p {
        font-size: 16px;
        line-height: 28px;
        color: #555;
    }

    .part {
        text-align: center;
        margin-top: 100px;

        .area {
            border-right: 1px solid rgba(193, 224, 249, 0.3);

            h1 {
                font-size: 50px;
                line-height: 28px;
                color: #006ecf;
                margin: 0 0 20px 0 !important;
            }

            h5 {
                font-size: 16px;
                line-height: 28px;
                color: #006ecf;
                margin: 0 !important;
            }

            &:last-child {
                border-right: 0 !important;
            }
        }
    }
}

.dark {
    background-color: #f8fcff;
}

.content-detail {
    position: absolute;
    top: 178px;
    left: 405px;

    h1 {
        font-size: 3.2rem;
        font-weight: 100 !important;
        line-height: 2rem;
        color: #fff;
    }

    p {
        color: #fff;
    }
}

.card-img {
    width: 118px;
    height: 118px;
    margin: 0 auto;
    transition: width 1s linear 2s;
    -webkit-transition: width 1s height 1s linear 2s;
}

.title {
    font-size: 16px !important;
    font-weight: bold;
}

.clear {
    margin-left: 0 !important;
    margin-right: 0 !important;
}

// 多场景解决方案
.card-over {
    padding: 8rem 2rem !important;

    .line {
        width: 40px;
        height: 2px;
        margin: 30px auto;
        background-color: #fff;
    }

    p, button {
        opacity: 0;
    }
}

// 多场景解决方案鼠标移动效果
.clear:hover {
    position: relative;

    .card-over {
        padding: 2.25rem !important;
        transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    }

    .mask {
        width: 300px;
        height: 480px;
        position: absolute;
        top: 0;
        left: 0;
        background-color: rgba(24, 121, 240, 0.6);
        transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    }

    .line {
        display: none;
    }

    p, button {
        opacity: 1;
        transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    }

    h5 {
        margin-top: 10px;
    }

    p {
        margin: 20px 0 50px;
    }
}

.carouse-img {
    width: 100%;
    height: 640px;
}

.content-one {
    text-align: center;
}

.margin-top {
    margin-top: 150px;
}

.content-last {
    position: relative;
}

.content-last-img {
    width: 275px;
    height: 250px;
}

.card-kind {
    padding: 20px 0;
    border: 0 !important;
}

.card-kind:hover {
    h5 {
        color: #30bbfc;
        transition: all 0.15s cubic-bezier(0.4, 0, 0.2, 1);
    }
}

.card-deck .card {
    margin-bottom: 15px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/OfficeSolution.vue